import React, { Component } from 'react';
import { Row, Field, Label, Button, ButtonLink }  from '../../generic';
import styled from 'styled-components';
import { validRadio } from '../../../helpers/check-required-fields';

const HorizontalDivider = styled.hr`
  border: 0;
  height: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  margin-bottom: 16px;
`

class RSVPOptions extends Component {
  render() {
    const { userEvent } = this.props

    return (
      <React.Fragment>
        <h2>RSVP Options</h2>
        {validRadio(userEvent.external_rsvp, false) ? (
          <p>Guests RSVP via a webpage that you send by email.</p>
        ) : (
          <p>Guests RSVP via a third-party service such as Eventbrite.</p>
        )}

      </React.Fragment>
    )
  }
}

export default RSVPOptions
